export const SOCIALS = {
    calendly: "https://calendly.com/chebbimohamedayoub/let-s-build-together-30min",
    upworkConsultation: "https://www.upwork.com/services/consultation/design-mohamed-ayoub-2028744848103590136?ref=project_share",
    linkedin: "https://www.linkedin.com/in/mohamed-ayoub-chebbi/",
    github: "https://github.com/chebbi603",
    upwork: "https://www.upwork.com/freelancers/ayoubc4",
    dribbble: "https://www.dribbble.com/chebbimedayoub",
    contra: "https://contra.com/mohamed_ayoub_chebbi_yigo1cqu?referralExperimentNid=DEFAULT_REFERRAL_PROGRAM&referrerUsername=mohamed_ayoub_chebbi_yigo1cqu",
    email: "chebbimohamedayoub@gmail.com"
};

export const EXTERNAL_LINKS = {
    swatchGithub: "https://github.com/chebbi603/swatch",
};

// Media uploaded under this category shows in About (photos of me), not Work
export const ABOUT_CATEGORY = "About me";

// Service categories: the Services cards and the Work labels both read these
export const CATEGORIES = {
    ai: "AI products",
    ux: "Product & UX",
    web: "Websites",
    brand: "Brand & visual",
};
